import Vue from 'vue'
import axios from 'axios'
import store from '@/store'
import { VueAxios } from './axios'
import { ACCESS_TOKEN } from '@/store/mutation-types'

/**
 * 【指定 axios的 baseURL】
 * 如果手工指定 baseURL: '/jeecg-boot'
 * 则映射后端域名，通过 vue.config.js
 * @type {*|string}
 */
const apiBaseUrl = process.env.VUE_APP_API_BASE // window._CONFIG['domianURL'] || '/api'
console.log('apiBaseUrl=', apiBaseUrl)

/**
 * 创建 axios 实例
 */
const service = axios.create({
	//baseURL: '/jeecg-boot',
	baseURL: apiBaseUrl, // api base_url
	// timeout: 9000, // 请求超时时间
})

/**
 *
 * @param {*} error
 */
const err = error => {
	if (error.response) {
		const data = error.response.data
		const token = Vue.ls.get(ACCESS_TOKEN)
		console.log('------异常响应------', token)
		console.log('------异常响应------', error.response.status)
		switch (error.response.status) {
			case 403:
				this.$message({ showClose: true, message: '拒绝访问', type: 'warning' })
				break
			case 500:
				//notification.error({ message: '系统提示', description:'Token失效，请重新登录!',duration: 4})
				if (token && data.message == 'Token失效，请重新登录') {
					// store.dispatch('Logout').then(() => {
					//     window.location.reload()
					// })
					// Modal.error({
					// 	title: '登录已过期',
					// 	content: '很抱歉，登录已过期，请重新登录',
					// 	okText: '重新登录',
					// 	mask: false,
					// 	onOk: () => {
					// 		store.dispatch('Logout').then(() => {
					// 			Vue.ls.remove(ACCESS_TOKEN)
					// 			window.location.reload()
					// 		})
					// 	},
					// })
				}
				break
			case 404:
				this.$message({ showClose: true, message: '很抱歉，资源未找到!', type: 'warning' })
				break
			case 504:
				this.$message({ showClose: true, message: '网络超时', type: 'warning' })
				break
			case 401:
				console.log('注销', token)
				//this.$message({ message: '未授权，请重新登录', type: 'warning' })
				if (token) {
					store.dispatch('Logout').then(() => {
						setTimeout(() => {
							window.location.reload()
						}, 1500)
					})
				}
				break
			default:
				this.$message(data.message)
				break
		}
	}
	return Promise.reject(error)
}

/**
 * request interceptor
 */
service.interceptors.request.use(
	config => {
		const token = Vue.ls.get(ACCESS_TOKEN)
		if (token) {
			config.headers['X-Access-Token'] = token // 让每个请求携带自定义 token 请根据实际情况自行修改
		}

		if (config.method == 'get') {
			config.params = {
				_t: Date.parse(new Date()) / 1000,
				...config.params,
			}
		}
		return config
	},
	error => {
		return Promise.reject(error)
	}
)

/**
 * response interceptor
 */
service.interceptors.response.use(response => {
	return response.data
}, err)

/**
 *
 */
const installer = {
	vm: {},
	install(Vue, router = {}) {
		Vue.use(VueAxios, router, service)
	},
}

export { installer as VueAxios, service as axios }
